import React, { useState } from "react";
import ResizableCell from "../../Utility/ResizableCell";
import { Table, Button } from "react-bootstrap";

export default function DetailsTable({ reports }) {
  const [editableCell, setEditableCell] = useState(null);
  const [activeSection, setActiveSection] = useState(null);
  const handleSectionToggle = (section) => {
    setActiveSection(section === activeSection ? null : section);
  };
  if (!reports?.raw_output || reports?.raw_output?.length === 0) {
    return (
      <p className="text-center">No raw output available for the report</p>
    );
  }
  let headers = [];
  if (Array.isArray(reports.raw_output)) {
    headers = Object.keys(reports?.raw_output[0]).filter(
      (key) => key !== "_id" && key !== "report_id"
    );
  }

  return (
    <div style={{ overflowX: "auto" }}>
      {Array.isArray(reports.raw_output) ? (
        <table className="table table-striped table-hover table-bordered shadow-sm table-responsive table-stack">
          <thead>
            <tr>
              {headers.map((header) => (
                <th
                  key={header}
                  style={{
                    textAlign: "center",
                    textTransform: "capitalize",
                    verticalAlign: "middle",
                  }}
                >
                  <ResizableCell>{header}</ResizableCell>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {reports?.raw_output.map((row) => (
              <React.Fragment key={row.item_uuid}>
                <tr>
                  {headers.map((header) => (
                    <td
                      data-label={header.replace(/_/g, " ")}
                      style={{
                        textAlign: "center",
                      }}
                      key={header}
                    >
                      {editableCell === row._id &&
                      header == "labor_category" ? (
                        <input
                          className="form-control mx-auto"
                          type="text"
                          defaultValue={row[header]}
                          onChange={(e) => {}}
                          style={{ width: "80%" }}
                        />
                      ) : typeof row[header] === "boolean" ? (
                        row[header] ? (
                          "Yes"
                        ) : (
                          "No"
                        )
                      ) : (
                        row[header]
                      )}
                    </td>
                  ))}
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </table>
      ) : (
        <>
          <div>
            <div className="d-flex justify-content-center flex-wrap">
              {Object.keys(reports?.raw_output).map((section, index) => (
                <Button
                  className="mx-2 my-4 d-block"
                  variant="primary"
                  size="sm"
                  key={index}
                  onClick={() => handleSectionToggle(section)}
                  style={{ textTransform: "capitalize" }}
                  disabled={activeSection === section}
                >
                  {section}
                </Button>
              ))}
            </div>
            {activeSection && reports?.raw_output[activeSection].length > 0 ? (
              <Table striped bordered hover responsive className="table-stack">
                <thead>
                  <tr>
                    {Object.keys(reports?.raw_output[activeSection][0]).map(
                      (key) => (
                        <th key={key}>{key}</th>
                      )
                    )}
                  </tr>
                </thead>
                <tbody>
                  {reports?.raw_output[activeSection].map((item, index) => (
                    <tr key={index}>
                      {Object.entries(item).map(([key, value], index) => (
                        <td key={index} data-label={key}>{value}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <div>
                {activeSection &&
                  reports?.raw_output[activeSection].length === 0 && (
                    <Table>
                      <tr>
                        <td
                          colSpan={
                            Object.keys(reports?.raw_output?.[0] || {})
                              .length || 1
                          }
                        >
                          No data available
                        </td>
                      </tr>
                    </Table>
                  )}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}
